function formatDisplayAmountValue(amount: number) {
  return (Math.round(amount * 100) / 100).toFixed(2)
}

export default formatDisplayAmountValue
